module.exports = __webpack_public_path__ + "img/reception-2.8e2f5908.svg";